/** @typedef {('en'|'th'|'zh'|'ru')} Locale */
/** @type {Locale[]} */
export const locales = ['en','th','zh','ru']